function initDate() {
  return {
    // 变量
    pageSource: '', // 页面渠道
    redirector: 'https://web.didachuxing.com/H5/Redirector?url=', // 重定向接口
    app_id: 'wxf18a88f56d23da94', // appid 微信专用
    isIPX: false // 是否是IPX
  }
}

const GLOBALDATA = initDate()

export function clearData() {
  Object.assign(GLOBALDATA, initDate())
}

export default GLOBALDATA
